var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin"}},[_c('div',{staticClass:"spacer"}),_c('NavBar'),_c('router-view'),_c('div',{staticClass:"space"}),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }